import type { AgentProviderRule } from "@p0security/shared/types/policy/types";
import { Form, Input, Select, Spin } from "@p0security/ui";
import { useIdentityProviders } from "hooks/useIdentityProviders";
import type React from "react";
import { useCallback, useMemo } from "react";

export const AgentProviderInput: React.FC<{
  value: AgentProviderRule;
  onChange: (value: AgentProviderRule) => void;
}> = ({ value, onChange }) => {
  const { error, loading, providers } = useIdentityProviders();

  const options = useMemo(
    () => providers.map(({ id }) => ({ value: id, label: id })),
    [providers]
  );

  const onChangeProvider = useCallback(
    (providerId: string) => onChange({ ...value, providerId }),
    [value, onChange]
  );

  const onChangeSubject = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) =>
      onChange({
        ...value,
        subjectPattern: event.target.value || undefined,
      }),
    [value, onChange]
  );

  return loading ? (
    <Spin />
  ) : (
    <Form layout="horizontal" requiredMark="optional">
      <Form.Item
        label="Provider"
        className="min-w-24 mb-2!"
        required
        validateStatus={error ? "error" : undefined}
        help={error}
      >
        <Select
          options={options}
          value={value.providerId}
          onChange={onChangeProvider}
          notFoundContent={error ?? "No installed identity providers"}
          status={error ? "error" : undefined}
        />
      </Form.Item>
      <Form.Item label="Subject pattern" className="mb-2!">
        <Input
          placeholder="^pattern$"
          value={value.subjectPattern}
          onChange={onChangeSubject}
        />
      </Form.Item>
    </Form>
  );
};
